import { GENEALOGY_REPORT_HEADERS as HEADERS } from "../../../../constants/analyticsGenealogy";

import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Paper,
  Chip,
  Grid,
  Divider,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Button,
  Checkbox,
  Tooltip,
  Alert,
  Snackbar,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import "./genealogyReport.scss";
import Label from "../../../../components/Label/Label";
import CAMHeader from "../../../../components/Header/CAMHeader";
import CAMDrawer from "../../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../../components/contsiners/InvestigatorContainer";
import TabsBar from "../../header/TabsNav";
import BreadcrumbsBar from "../../header/BreadcrumbNav";

// import { fetchGenealogySingleReport } from "../../../../redux/genealogy/actions";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { saveGenealogyReport } from "../../../../redux/genealogy/actions";
import { hasPermission } from "../../../../utils/permissions";
import {
  GENEALOGY_PERMISSIONS,
  PERMISSION_MODULES,
} from "../../../../constants/permissions";

const tableCellSx = {
  padding: "8px",
  fontSize: 12,
  whiteSpace: "nowrap",
};

// import Pagination from "../../../../components/Pagination";

const toLabelCase = (text) => {
  if (!text) return "";

  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// import React from "react";
// import { Box, Typography, Divider, Tooltip } from "@mui/material";

const InfoChips = ({ data }) => {
  const toLabelCase = (text) => {
    if (!text) return "";
    return text
      .toString()
      .toLowerCase()
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const formattedData = Object.entries(data || {}).map(([key, value]) => {
    let formattedValue = value;
    let originalValue = value; // 👈 control tooltip separately

    // ✅ Fix: show product description name instead of ID
    if (key === "product_description") {
      formattedValue = data.product_description_name || value;
      originalValue = data.product_description_name || value; // 🔥 fix tooltip
    }

    // ✅ Handle selected_batches
    if (key === "selected_batches") {
      if (Array.isArray(value)) {
        formattedValue = `${value.length} selected`;
        originalValue = value.join(", "); // optional: better tooltip
      } else if (typeof value === "string") {
        const count = value
          .split(",")
          .map((v) => v.trim())
          .filter(Boolean).length;

        formattedValue = `${count} selected`;
        originalValue = value; // optional: better tooltip
      }
    }

    return {
      label: key,
      value: formattedValue,
      originalValue,
    };
  });

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap", // ✅ allow multiple rows
        whiteSpace: "normal", // ✅ allow wrapping
        // px: 1.5,
        // py: 1,
        alignItems: "center",
        maxWidth: "100%", // ✅ prevent overflow outside parent
      }}
    >
      {formattedData.map((item, index) => (
        <Tooltip
          key={index}
          title={
            typeof item.originalValue === "string"
              ? item.originalValue
              : JSON.stringify(item.originalValue)
          }
          arrow
        >
          <Box
            sx={{
              background: "#e0e0e0",
              borderRadius: "12px",
              px: 0.8,
              py: 0.2,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              height: 24, // ✅ compact height
              flexShrink: 0, // 🔥 prevent shrinking
              cursor: "default",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#666",
                lineHeight: 1,
              }}
            >
              {toLabelCase(item.label)}
            </Typography>

            <Divider orientation="vertical" flexItem sx={{ mx: 0.3 }} />

            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 500,
                color: "#222",
                lineHeight: 1,
              }}
            >
              {item.value}
            </Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

const Row = ({ row, visibleColumns, COLUMN_CONFIG, parameter }) => {
  const getValue = (key, row) => {
    switch (key) {
      case "dynamic_parameter":
        return parameter?.name ? (row[parameter.name] ?? "-") : "-";

      case "component_material_description":
        return row.component_material_description || "-";

      case "counter_split":
        const counter = row.counter;
        const split = row.split;

        if (counter && split) return `${counter}.${split}`;
        if (counter) return counter;
        if (split) return split;
        return "-";

      case "component_batch_number":
        return row.component_batch_number || "-";

      case "component_production_purchase_document":
        return row.component_production_purchase_document || "-";

      default:
        return row[key] ?? "-";
    }
  };

  return (
    <TableRow hover>
      {COLUMN_CONFIG.filter((col) => visibleColumns.includes(col.key)).map(
        (col) => (
          <TableCell key={col.key} sx={tableCellSx}>
            <Label
              text={getValue(col.key, row)}
              fontSize={col.key === "produced_material" ? 14 : 13}
              fontWeight={col.key === "produced_material" ? 500 : 400}
            />
          </TableCell>
        ),
      )}
    </TableRow>
  );
};
// const COLUMN_CONFIG = [
//   { key: "produced_material", label: "Material Number" },
//   { key: "material_description", label: "Material Description" },
//   { key: "product_type", label: "Product Type" },
//   { key: "sap_batch_production_date", label: "SAP Production Date" },
//   { key: "vendor_batch_number", label: "Vendor Batch Number" },
//   { key: "production_purchase_document", label: "Purchase Document" },
// ];

const GenealogyReport = ({ data, parameter }) => {
  const canDownloadExcel = hasPermission(
    PERMISSION_MODULES.GENEALOGY,
    GENEALOGY_PERMISSIONS.DOWNLOAD_EXCEL,
  );
  const COLUMN_CONFIG = [
    { key: "segment", label: "Segment" },
    { key: "parent_hierarchy_level", label: "Parent Hierarchy Level" },
    // { key: "counter", label: "Counter" },
    // { key: "split", label: "Split" },
    { key: "counter_split", label: "Counter.Split" },
    { key: "produced_material", label: "Produced Material" },
    {
      key: "produced_material_description",
      label: "Produced Material Description",
    },
    { key: "produced_batch_number", label: "Produced Batch Number" },
    { key: "produced_product_type", label: "Product Type" },
    { key: "produced_plant_code", label: "Plant Code" },
    { key: "sap_batch_production_date", label: "SAP Production Date" },
    { key: "vendor_batch_number", label: "Produced Vendor Batch Number" },
    {
      key: "production_purchase_document",
      label: "Produced Production/Purchase Document",
    },
    { key: "child_hierarchy_level", label: "Child Hierarchy" },
    { key: "component_material", label: "Component Material" }, // These may not exist directly → handled via mapping
    {
      key: "component_material_description",
      label: "Component Material Description",
    },
    {
      key: "component_batch_number",
      label: "Component Batch Number",
    },
    {
      key: "component_product_type",
      label: "Component Product Type",
    },
    {
      key: "component_material_family",
      label: "Material Family",
    },
    // ✅ Add only if parameter exists
    ...(parameter?.name
      ? [
          {
            key: "dynamic_parameter",
            label: parameter.name,
          },
        ]
      : []),
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const reportDetails = useSelector((state) => state?.genealogy?.reportData);

  // const { loader, apiError, message, data = [] } = reportDetails || {};
  //
  const reportData = data[0]?.table_data;
  const headersData = data[0]?.filters;

  // const [anchorEl, setAnchorEl] = useState(null);
  // const [selectedRow, setSelectedRow] = useState(null);

  const [searchValue, setSearcValue] = useState("");

  const [visibleColumns, setVisibleColumns] = useState(
    COLUMN_CONFIG.map((col) => col.key),
  );

  const [excelError, setExcelError] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  // const [page, setPage] = useState(1);

  // const open = Boolean(anchorEl);

  // useEffect(() => {
  //   dispatch(fetchGenealogySingleReport({}));
  // }, []);

  // const handleMenuClick = (event, row) => {
  //   setAnchorEl(event.currentTarget);
  //   setSelectedRow(row);
  // };

  // const handleMenuClose = () => {
  //   setAnchorEl(null);
  //   setSelectedRow(null);
  // };

  // const handleView = () => {
  //   handleMenuClose();

  //   navigate(`/genealogy/view`, {
  //     state: {
  //       report_id: selectedRow?.id,
  //     },
  //   });
  // };

  // if (loader) {
  //   return (
  //     <Box py={6} display="flex" justifyContent="center">
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // if (apiError) {
  //   return (
  //     <Box py={6} display="flex" justifyContent="center">
  //       <Typography color="error">{message}</Typography>
  //     </Box>
  //   );
  // }

  // if (!reportData?.length) {
  //   return (
  //     <Box py={6} textAlign="center">
  //       <Label text="No Records found." />
  //     </Box>
  //   );
  // }

  const handleSearch = () => {
    // dispatch(
    //   fetchGenealogySingleReport({
    //     name: searchValue,
    //   }),
    // );
  };

  const handleDownloadExcel = () => {
    if (!canDownloadExcel) return;
    const MAX_CELL_LENGTH = 32767;

    const getValue = (key, row) => {
      switch (key) {
        case "dynamic_parameter":
          return parameter?.name ? (row[parameter.name] ?? "") : "";

        case "component_material_description":
          return row.component_material_description || "-";

        case "counter_split":
          const counter = row.counter;
          const split = row.split;

          if (counter && split) return `${counter}.${split}`;
          if (counter) return counter;
          if (split) return split;
          return "-";

        case "component_batch_number":
          return row.component_batch_number || "-";

        case "component_production_purchase_document":
          return row.component_production_purchase_document || "-";

        default:
          return row[key] ?? "";
      }
    };

    if (!reportData || !reportData.length) return;

    try {
      reportData.forEach((row, rowIndex) => {
        COLUMN_CONFIG.forEach((col) => {
          if (visibleColumns.includes(col.key)) {
            const value = getValue(col.key, row);

            if (typeof value === "string" && value.length > MAX_CELL_LENGTH) {
              throw new Error(
                `Cell value too long at row ${rowIndex + 1}, column "${col.label}". Max allowed is 32,767 characters.`,
              );
            }
          }
        });
      });

      Object.entries(headersData || {}).forEach(([key, value]) => {
        if (typeof value === "string" && value.length > MAX_CELL_LENGTH) {
          throw new Error(`Header "${key}" exceeds 32,767 character limit.`);
        }
      });

      const tableRows = reportData.map((row) => {
        const obj = {};

        COLUMN_CONFIG.forEach((col) => {
          if (visibleColumns.includes(col.key)) {
            obj[col.label] = getValue(col.key, row);
          }
        });

        return obj;
      });

      const worksheet = XLSX.utils.json_to_sheet(tableRows, {
        origin: "A11",
      });

      const headerEntries = Object.entries(headersData || {})
        .filter(([key]) => key !== "product_description") // ❌ remove ID field
        .map(([key, value]) => [
          toLabelCase(
            key === "product_description_name" ? "product_description" : key,
          ),
          value,
        ]);

      XLSX.utils.sheet_add_aoa(worksheet, headerEntries, {
        origin: "A1",
      });

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Genealogy Report");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const fileData = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(fileData, "Genealogy_Report.xlsx");
    } catch (error) {
      console.error("Excel validation error:", error);
      setExcelError(error.message || "Excel export failed.");
      setOpenSnackbar(true);
    }
  };

  //   const handleSave = async (actionType) => {
  //     // const payload = {
  //     //   action: actionType,
  //     //   ...date,
  //     //   ...filters,
  //     // };

  //     const formatDate = (d) =>
  //       new Date(d).toLocaleDateString("en-IN", {
  //         day: "2-digit",
  //         month: "short",
  //         year: "numeric",
  //       });

  //     let payload = {
  //       report_name: reportName,
  //       created_by: localStorage.getItem("userid"),
  // selected_columns:[],
  //       status: actionType,

  //       filters_used: filters,
  //     };

  //     try {
  //       console.log("Generate report", payload);

  //       const res = await dispatch(saveGenealogyReport(payload));

  //       if (res && res.success) {
  //         navigate("/genealogy");
  //       } else {
  //         navigate("/genealogy", {
  //           state: {
  //             reportId: res.data.report_id,
  //           },
  //         });
  //         console.error("Report generation failed", res);
  //       }
  //     } catch (err) {
  //       navigate("/genealogy", {
  //         state: {
  //           // reportId: res.data.report_id,
  //         },
  //       });
  //     }
  //   };

  return (
    <div>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        // px={1}
        py={1}
        gap={1}
        flexWrap="wrap" // important for responsiveness
      >
        {/* LEFT → Chips */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <InfoChips data={headersData} />
        </Box>

        {/* RIGHT → Controls */}
        <Box display="flex" alignItems="flex-end" gap={2} flexShrink={0}>
          {" "}
          <FormControl size="small" sx={{ width: 200 }}>
            <InputLabel
              shrink
              sx={{
                backgroundColor: "#fff", // match your background
                px: 0.5, // small padding to cover border
              }}
            >
              Columns
            </InputLabel>
            <Select
              multiple
              value={visibleColumns}
              onChange={(e) => setVisibleColumns(e.target.value)}
              renderValue={(selected) =>
                selected
                  .map(
                    (key) =>
                      COLUMN_CONFIG.find((col) => col.key === key)?.label,
                  )
                  .join(", ")
              }
            >
              {COLUMN_CONFIG.map((col) => (
                <MenuItem key={col.key} value={col.key}>
                  <Checkbox checked={visibleColumns.includes(col.key)} />
                  {col.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {canDownloadExcel && <Button variant="outlined" onClick={handleDownloadExcel}>
            <Label text="Download Excel" />
          </Button>}
        </Box>
      </Box>
      <Divider sx={{ mx: 2 }} />

      <Box className="genealogy-report-table-wrapper">
        <TableContainer className="genealogy-report-table-scroll">
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow sx={{ background: "#E9E9E9" }}>
                {COLUMN_CONFIG.filter((col) =>
                  visibleColumns.includes(col.key),
                ).map((col, i) => (
                  <TableCell
                    key={i}
                    className="report-table-header-cell"
                    sx={{
                      width: "150px", // ✅ add px
                      minWidth: "150px",
                      maxWidth: "150px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <Label text={col.label} fontSize="14px" fontWeight="700" />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {reportData?.map((row, i) => (
                <Row
                  key={i}
                  row={row}
                  visibleColumns={visibleColumns}
                  COLUMN_CONFIG={COLUMN_CONFIG}
                  parameter={parameter}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {/* <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
          <MenuItem onClick={handleView}>
            <Label text="View" />
          </MenuItem>
        </Menu> */}

      {/* <Box className="viz-list-pagination">
          <Pagination
            count={totalPages}
            page={page}
            onChange={handlePageChange}
          />
        </Box> */}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          severity="error"
          onClose={() => setOpenSnackbar(false)}
          variant="filled"
        >
          {excelError}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default GenealogyReport;
